import React, { useEffect, useState } from 'react';
import * as R from 'ramda';
import { ShippingAddressComponent } from '../components/shipping-address.component';
import storePersist from '../../../redux/storePersist';
export const ShippingAddressContainer = ({ onInnerFormChange, selectShippingAddress,isAddress }: any) => {
  const [
    stateValues,
    setStateValues
  ] = useState<any>([])

  const handleFilterToStates = (event: any) => {
    onInnerFormChange(
      event,
      'ShippingAddress.CountryId',
      selectShippingAddress?.ShippingAddress
    );

    if (event) {
      const filterStates: any = R.filter(
        (value: any) => value.CountryId === event,
        statesItems
      );
      if (filterStates.length) {
        setStateValues(filterStates);
      } else {
        setStateValues(statesItems);
      }
    } else {
      setStateValues([])
    }
  }

useEffect(() => {
  if(selectShippingAddress?.ShippingAddress?.CountryId){
    handleFilterToStates(selectShippingAddress?.ShippingAddress?.CountryId)
  }
 
}, [])

const statesItems = storePersist?.get("states")?.current?.items;
const countriesItems = storePersist?.get("countries")?.current?.items;
const librariesItems = storePersist?.get("library")?.current;

  return (
        <ShippingAddressComponent
        isAddress={isAddress}
            onFilterToStates={handleFilterToStates}
            onInnerFormChange={onInnerFormChange}
            selectShippingAddress={selectShippingAddress}
            stateValues={stateValues}
            countries={countriesItems}
            libraries={librariesItems}
        />
  )
}
